module.exports = __webpack_public_path__ + "img/mainbg.df37e86e.png";